<template>
  <div class="tw-h-screen tw-w-full">
    <div class="tw-flex tw-h-full">
      <div
        class="tw-hidden md:tw-flex tw-justify-center tw-items-center md:tw-w-1/2 xl:tw-w-1/3 tw-bg-cover tw-bg-top tw-bg-no-repeat"
        :style="{ backgroundImage: `url(${loginSplash})` }"
      >
        <RouterLink to="/" class="tw-w-[60%] tw-max-w-[280px]">
          <InocuLogo />
        </RouterLink>
      </div>

      <div class="tw-flex tw-justify-center tw-items-center md:tw-w-1/2 xl:tw-w-2/3 tw-bg-white">
        <div class="tw-w-3/4 tw-mx-auto tw-min-w-[350px] tw-px-8">
          <LoginCredentials
            v-if="currentLoginStep === 'loginCredentials'"
            @forgotPassword="forgotPasswordClicked"
            @nextChallenge="getLoginNextChallenge"
            @needsTenantSelection="showTenantSelection"
          />

          <TenantSelection v-else-if="currentLoginStep === 'tenantSelection'" />

          <ResetPassword
            v-else-if="currentLoginStep === 'setNewPassword'"
            @nextChallenge="getLoginNextChallenge"
            @needsTenantSelection="showTenantSelection"
          />

          <MfaSetup
            v-else-if="currentLoginStep === 'mfaSetup'"
            @nextChallenge="getLoginNextChallenge"
            @needsTenantSelection="showTenantSelection"
          />

          <CodeVerification
            v-else-if="currentLoginStep === 'codeVerification'"
            :codeReceivedFrom="codeReceivedFrom"
            @needsTenantSelection="showTenantSelection"
          />

          <ForgotPassword
            v-else-if="currentLoginStep === 'forgotPassword'"
            @backToLogin="backToLogin"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, type Ref } from 'vue';
import { RouterLink } from 'vue-router';

import {
  LoginCredentials,
  ForgotPassword,
  ResetPassword,
  CodeVerification,
  MfaSetup,
  TenantSelection,
} from '@/components/login';

import InocuLogo from '@/assets/images/inocu-logo.svg';
import loginSplash from '@/assets/images/login-splash.jpg';

// Start with login credentials (no workspace selection needed)
const currentLoginStep = ref('loginCredentials');
const codeReceivedFrom: Ref<'TOTP' | 'SMS' | null> = ref(null);

const getLoginNextChallenge = (nextChallenge: string) => {
  switch (nextChallenge) {
    case 'NEW_PASSWORD_REQUIRED':
      currentLoginStep.value = 'setNewPassword';
      break;
    case 'MFA_SETUP':
      currentLoginStep.value = 'mfaSetup';
      break;
    case 'SOFTWARE_TOKEN_MFA':
      currentLoginStep.value = 'codeVerification';
      codeReceivedFrom.value = 'TOTP';
      break;
    case 'SMS_MFA':
      currentLoginStep.value = 'codeVerification';
      codeReceivedFrom.value = 'SMS';
      break;
  }
};

const showTenantSelection = () => {
  currentLoginStep.value = 'tenantSelection';
};

const forgotPasswordClicked = () => {
  currentLoginStep.value = 'forgotPassword';
};

const backToLogin = () => {
  currentLoginStep.value = 'loginCredentials';
};
</script>

<style scoped>
/* Using Tailwind classes - no additional styles needed */
</style>
